import { Factory } from 'miragejs'

export const keyword = Factory.extend({
  title(i) {
    const values = [
      'Blockchain technology',
      'Polygon Blockchain technology',
      'Blockchain developers',
      'Riot Blockchain Stock',
      'Blockchain technology explained',
      'Polygon Blockchain technology',
    ]
    return values[i % values.length]
  },
  volume(i) {
    const values = [232134, 423545, 879879]
    return values[i % values.length]
  },
  cpc(i) {
    const values = [0.45, 0.34, 0.23]
    return values[i % values.length]
  },
  cd(i) {
    const values = [0.12, 0.23, 0.34]
    return values[i % values.length]
  },
  monthly_change(i) {
    const values = [12, 45, 78]
    return values[i % values.length]
  },
  difficulty(i) {
    const values = [43, 12, 85]
    return values[i % values.length]
  },
})
